import logo from './logo.svg';
import './App.css';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from './components/Main';
import Page404 from './components/Page404'
import DocumentationComponent from "./quick-guide-components/DocumentationComponent";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/docs/*" element={<Main />} />
                <Route path="/" element={<Main />} />
                <Route path="/quick/docs/*" element={<DocumentationComponent />} />
            </Routes>
        </BrowserRouter>
    );
}
